<template>
  <LoadingWrapperSpinner
    request-id="loadCartItems"
    :response-data="getItemsCart"
    :style="isRequestLoading('loadCartItems') ? { height: '90vh' } : {}"
  >
    <div
      v-for="(supplierData, supplierName) in groupedMaterialVariants"
      :key="supplierName"
      style="border: 1px solid rgb(224, 224, 224); margin-top: 40px; padding: 20px; border-radius: 10px;"
    >
      <div
        class="headline"
      >
        <div style="display: flex; justify-content: center; align-items:flex-start;">
          <h2>{{ supplierName }}</h2>
          <b-button
            v-b-toggle="'collapse-' + supplierName"
            class="m-1"
            variant="light"
          >
            <b-icon-arrows-expand />
          </b-button>
        </div>
        <div>
          <b-button
            :key="`pdf-button-${supplierName}`"
            v-b-tooltip.hover.bottom
            :title="!selectedRows[supplierName]?.length ? 'Select at least one material variant' : 'Export to PDF'"
            :disabled="!selectedRows[supplierName]?.length"
            class="pdf-button"
            @click="exportToPDF(supplierName)"
          >
            Export to PDF
          </b-button>
          <b-button
            :key="`order-button-${supplierName}`"
            v-b-tooltip.hover.bottom
            :title="!selectedRows[supplierName]?.length ? 'Select at least one material variant' : 'Order Now'"
            :disabled="!selectedRows[supplierName]?.length"
            class="pdf-button order"
            style="margin-left: 10px;"
            @click="createOrder(supplierName)"
          >
            {{ $t('OrderNow') }}
          </b-button>
        </div>
      </div>
      <div>
        <b-collapse
          :id="'collapse-' + supplierName"
          :visible="!isOpen[supplierName]"
        >
          <table class="custom-table">
            <thead>
              <tr>
                <th>
                  <input
                    v-model="selectAll[supplierName]"
                    type="checkbox"
                    @change="selectAllRows(supplierName)"
                  >
                </th>
                <th>{{ $t('No') }}</th>
                <th>{{ $t('MaterialVariantName') }}</th>
                <th>{{ $t('Description') }}</th>
                <th>{{ $t('Color') }}</th>
                <th>{{ $t('Price') }}({{ $t('Meter') }}/{{ $t('Part') }})</th>
                <th>{{ $t('AmoutNeeded') }}</th>
                <th>{{ $t('OrderedSupplier') }}</th>
                <th>{{ $t('Change') }}</th>
                <th>{{ $t('OptionalSupplier') }}</th>
                <th>{{ $t('Photo') }}</th>
                <th>{{ $t('State') }}</th>
                <th style="text-align: center;">
                  {{ $t('Actions') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(row, index) in supplierData"
                :key="row.id"
              >
                <td>
                  <input
                    type="checkbox"
                    :checked="isRowSelected(supplierName, row)"
                    @change="toggleRowSelection(supplierName, row)"
                  >
                </td>
                <td>{{ index + 1 }}.</td>
                <td>{{ row.materialVariantName }}</td>
                <td>{{ row.description }}</td>
                <td>{{ row.color }}</td>
                <td>{{ row.orderedPrice ? `${numbersWithcomma(row.orderedPrice)}€` : "0.00€" }}</td>
                <td>{{ row.amount }}</td>
                <td>{{ row.mainSupplierName }}</td>
                <td>
                  <b-button
                    style="background: none; color: #FF274F; width: 60%;"
                    class="buttonSubmit"
                    @click="changeSuppliers(row)"
                  >
                    <b-icon-arrow-left-right />
                  </b-button>
                </td>
                <td>{{ row.secondSupplierName }}</td>
                <td>
                  <img
                    v-b-tooltip="$t('ClickToViewPhoto')"
                    style="height: 40px; border-radius: 3px;cursor:pointer; "
                    :src="row.fileUrl"
                    alt=""
                    @click.stop="getAllImages(row)"
                  >
                </td>
                <td style="text-align: left;color: black; font-weight: 400;">
                  <div
                    style="background-color: rgb(255, 235, 197); padding: 7px; border-radius: 7px; color: rgb(225, 147, 4);"
                  >
                    ⦿ {{ $t(row.state) }}
                  </div>
                </td>
                <td
                  style="text-align: center;"
                  @click="togglePopup(row.id)"
                >
                  <img
                    src="../../assets/images/actionDots.svg"
                    alt=""
                  >
                  <div
                    v-if="showPopup[row.id]"
                    class="popup"
                  >
                    <div
                      v-b-modal.edit-variant-cart
                      style="cursor: pointer; text-align: center;"
                      @click="sendPropEdit(row)"
                    >
                      <button class="actionEdit">
                        <b-icon-pencil />{{ $t('Edit') }}
                      </button>

                    </div>
                    <div
                      v-b-modal.confirmation-modal
                      style="cursor: pointer; text-align: center;"
                      @click="sendPropDelete(row)"
                    >
                      <button class="actionDelete">
                        <b-icon-trash />{{ $t('Delete') }}
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </b-collapse>
      </div>
    </div>
    <CreateMaterialVariantsOrder
      :title="$t('OrderMaterialVariants')"
      :body-text="$t('OrderMaterialQuest')"
      :selected-rows="selectedRowsForOrder"
      @orderArray="createOrderCart"
    />
    <EditMaterialVariantOrder
      :edit-form="editForm"
      @editOrder="editMaterialOrder"
    />
    <ConfirmationModal
      :title="$t('RemoveFromCart')"
      :body-text="`${$t('RemoveConfirm')} **${orderItemCartName}** ${$t('FromCart')}`"
      @Confirm="removeFromCart"
    />
    <vue-easy-lightbox
      :esc-disabled="false"
      :visible="image.visible"
      :imgs="image.imgs"
      :index="image.index"
      @hide="handleHide"
    />
  </LoadingWrapperSpinner>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CreateMaterialVariantsOrder from '@/components/cart/modals/CreateMaterialVariantsOrder.vue'
import EditMaterialVariantOrder from '@/components/cart/modals/EditMaterialVariantOrder.vue'
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import moment from 'moment';
import VueEasyLightbox from 'vue-easy-lightbox'
import ConfirmationModal from '@/modals/ConfirmationModal.vue'
import { client } from '../../domainConfig'
import {
  xharraIcon, iconLogo, qrCodeLogo, facebookLogo, instaLogo, mailLogo,
} from '../iconsImageUsers';


export default {
  components: {
    CreateMaterialVariantsOrder,
    EditMaterialVariantOrder,
    ConfirmationModal,
    VueEasyLightbox,
  },
  data() {
    return {
      image: {
        zoom: 1,
        imgs: [], // Img Url , string or Array of string
        visible: false,
        index: 0, //
      },
      showPopup: {},
      footerIcon: 'data:image/png;base64,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',
      digitIcon: 'data:image/png;base64,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',
      client: client.clientName,
      selectedRows: {},
      selectedRowsForOrder: {},
      selectAll: {},
      isOpen: {},
      editForm: {
        amount: null,
        orderedPrice: null,
      },
      orderItemCartId: null,
      orderItemCartName: null,
      tableColumns: [
        {
          label: 'Material Variant Name',
          field: 'materialVariantName',
        },
        {
          label: 'Color',
          field: 'color',
        },
        {
          label: 'Price',
          field: 'orderedPrice',
        },
        {
          label: 'Amount needed',
          field: 'amount',
        },
        {
          label: 'Main Supplier',
          field: 'mainSupplierName',
        },
        {
          label: 'Second Supplier',
          field: 'secondSupplierName',
        },
        {
          label: 'State',
          field: 'state',
        },
        {
          label: 'Edit',
          field: 'edit',
        },
        {
          label: 'Delete',
          field: 'delete',
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['getMaterialVariantCart', 'getLanguage', 'getItemsCart', 'getLoggedInUser']),
    isRowSelected() {
      return (supplierName, row) => { return !!this.selectedRows[supplierName]?.find((selectedRow) => { return selectedRow.id === row.id }) };
    },
    isAllRowsSelected() {
      return (supplierName) => { return this.selectedRows[supplierName]?.length === this.groupedMaterialVariants[supplierName]?.length };
    },
    groupedMaterialVariants() {
      return this.getItemsCart.reduce((grouped, variant) => {
        if (!grouped[variant.mainSupplierName]) {
          grouped[variant.mainSupplierName] = [];
        }
        grouped[variant.mainSupplierName].push(variant);
        return grouped;
      }, {});
    },
  },
  created() {
    this.loadCartItems({ state: 'Pending' })
    // this.groupedMaterialVariants.forEach((variant) => {
    //   this.$set(this.isOpen, variant.mainSupplierName, true);
    // });
  },
  methods: {
    ...mapActions(['loadCartItems', 'addCartOrder', 'changeSupplier', 'editCartMaterialVariant', 'deleteFromCart']),
    numbersWithcomma(value) {
      const options = {
        style: 'decimal', // Other options: 'currency', 'percent', etc.
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      };
      return value.toLocaleString('en-US', options);
    },
    async getAllImages(item) {
      console.log('itemi', item)
      this.image.imgs = [];
      this.image.imgs.push({
        src: item.fileUrl,
      });
      this.show();
    },
    show() {
      this.image.visible = true
    },
    handleHide() {
      this.image.visible = false
      this.image.imgs.length = []
    },
    toggleCollapse(supplierName) {
      this.$set(this.isOpen, supplierName, !this.isOpen[supplierName]);
    },
    removeFromCart(value) {
      if (value == true) {
        this.deleteFromCart({
          id: this.orderItemCartId,
          successCallback: () => {
            this.loadCartItems({ state: 'Pending' })
          },
        })
      }
    },
    editMaterialOrder(value) {
      this.editCartMaterialVariant({
        id: this.orderItemCartId,
        object: value,
        successCallback: () => {
          this.loadCartItems({ state: 'Pending' })
        },
      })
    },
    createOrderCart({ orderIds, supplierId }) {
      console.log('orderIds:', orderIds);
      console.log('supplierId:', supplierId);

      this.addCartOrder({
        supplierId,
        object: orderIds,
        successCallback: () => {
          this.loadCartItems({ state: 'Pending' });
        },
      });
    },
    changeSuppliers(value) {
      this.changeSupplier({
        variantItemCartId: value.id,
        newOrderedSupplierId: value.secondSupplierId,
        successCallback: () => {
          this.loadCartItems({ state: 'Pending' })
        },
      })
    },
    sendPropEdit(value) {
      this.orderItemCartId = value.id
      this.editForm.amount = value.amount
      this.editForm.orderedPrice = value.orderedPrice
    },
    sendPropDelete(value) {
      this.orderItemCartId = value.id
      this.orderItemCartName = value.materialVariantName
    },
    selectAllRows(supplierName) {
      const currentSelectedRows = this.selectedRows[supplierName] || [];
      const allRows = this.groupedMaterialVariants[supplierName] || [];

      if (this.selectAll[supplierName] == true) {
        const newSelectedRows = [...currentSelectedRows, ...allRows.filter((row) => { return !currentSelectedRows.includes(row) })];
        this.selectedRows[supplierName] = newSelectedRows;
      } else {
        const newSelectedRows = currentSelectedRows.filter((row) => { return !allRows.includes(row) });
        this.selectedRows[supplierName] = newSelectedRows;
      }
    },
    toggleRowSelection(supplierName, row) {
      const selectedRows = this.selectedRows[supplierName] || [];
      const index = selectedRows.findIndex((selectedRow) => { return selectedRow.id === row.id });

      if (index === -1) {
        this.$set(this.selectedRows, supplierName, [...selectedRows, row]);
      } else {
        selectedRows.splice(index, 1);
        this.$set(this.selectedRows, supplierName, selectedRows);
      }

      // Check if there are no selected rows and update selectAll accordingly
      this.selectAll[supplierName] = this.selectedRows[supplierName]?.length === this.groupedMaterialVariants[supplierName]?.length;
    },
    toggleAllRowsSelection(supplierName) {
      const allRowsSelected = this.isAllRowsSelected(supplierName);

      this.selectedRows[supplierName] = allRowsSelected
        ? []
        : this.groupedMaterialVariants[supplierName]?.slice() || [];
    },
    createOrder(supplierName) {
      const selectedRows = this.selectedRows[supplierName] || [];
      this.selectedRowsForOrder = selectedRows;
      this.$bvModal.show('create-variants-order');
    },
    exportToPDF(supplierName, customWidth) {
      const selectedRows = this.selectedRows[supplierName] || [];

      if (selectedRows.length === 0) {
        return;
      }

      const headers = [
        `${this.$t('VariantName')}`,
        `${this.$t('Description')}`,
        `${this.$t('Color')}`,
        `${this.$t('TotalOrderedAmount')}`,
        `${this.$t('PricePerUnit')}`,
        `${this.$t('Total')}`,
      ];

      // eslint-disable-next-line new-cap
      const pdf = new jsPDF({
        orientation: 'landscape',
        unit: 'pt',
      });

      pdf.setProperties({
        format: [customWidth, pdf.internal.pageSize.getHeight()],
      });

      // Title
      const title = this.$t(supplierName);
      const titleX = pdf.internal.pageSize.getWidth() / 2;
      const titleY = 40;
      pdf.setFontSize(25);
      pdf.setTextColor(255, 255, 255);
      pdf.text(title, titleX, titleY, { align: 'center' });

      // Printing Date
      const currentTime = moment().format('MMM D, YYYY');
      const timeX = pdf.internal.pageSize.getWidth() / (10 / 9);
      const timeY = 96;
      const textWidth = 100;
      pdf.setFontSize(13);
      pdf.setTextColor(0, 0, 0);
      const labelText = `${this.$t('Printing Date')}: `;
      pdf.text(labelText, timeX, timeY, { align: 'right' });

      pdf.setTextColor(255, 0, 0);
      const textArray = pdf.splitTextToSize(currentTime, textWidth);
      textArray.forEach((line, index) => {
        const yOffset = timeY + ((index + 1) * 15);
        pdf.text(line, timeX, yOffset, { align: 'right' });
      });

      // Time
      const currentHour = moment().format('HH:mm:ss');
      const hourX = timeX;
      const hourY = timeY + (textArray.length + 1) * 15;
      pdf.setFontSize(13);
      pdf.setTextColor(0, 0, 0);
      pdf.text(`${this.$t('Time')}: ${currentHour}`, hourX, hourY, { align: 'right' });

      // Compute dynamic table startY
      const tableStartY = hourY + 20;

      // Table data
      const data = selectedRows.map((row) => {
        return [
          row.materialVariantName,
          row.description || `${this.$t('NoDescription')}`,
          row.color,
          row.amount,
        ]
      });

      const tableOptions = {
        startY: tableStartY,
        head: [headers],
        body: data,
        headStyles: {
          fillColor: [249, 249, 249],
          textColor: [96, 96, 96],
          lineColor: [181, 181, 181],
          lineWidth: 0.1,
          halign: 'left',
        },
        bodyStyles: {
          textColor: [0, 0, 0],
          lineWidth: 0.1,
        },
        pageBreak: 'auto',
        columnStyles: {
          0: { columnWidth: pdf.internal.pageSize.getWidth() / 6 },
          1: { columnWidth: pdf.internal.pageSize.getWidth() / 6 },
          2: { columnWidth: pdf.internal.pageSize.getWidth() / 6 },
          3: { columnWidth: pdf.internal.pageSize.getWidth() / 6 },
          4: { columnWidth: pdf.internal.pageSize.getWidth() / 6 },
        },
      };

      // Draw table
      pdf.autoTable(tableOptions);

      // Check if footer needs to go to next page
      const finalY = pdf.lastAutoTable.finalY;
      const pageHeight = pdf.internal.pageSize.getHeight();
      const footerHeightNeeded = 140;

      if (finalY + footerHeightNeeded > pageHeight) {
        pdf.addPage();
      }

      // Footer content
      const staticContent = () => {
        const titleOrdered = `${this.$t('Ordered')} : ${supplierName}`;
        const titleOrderedY = 50;
        const titleOrderedX = 40;
        pdf.setFontSize(30);
        pdf.setFont('Helvetica', 'normal');
        pdf.setTextColor(0, 0, 0);
        pdf.text(titleOrdered, titleOrderedX, titleOrderedY, { align: 'left' });

        const iconWidth = 150;
        const iconHeight = 100;
        const iconY = 0;
        const iconX = pdf.internal.pageSize.getWidth() - 180;
        pdf.addImage(xharraIcon, 'PNG', iconX, iconY, iconWidth, iconHeight);

        const locations = [
          { name: 'PRISHTINË - Çagllavicë', name2: 'Rrethi Marigona Residence', phone: '+383 44 503 399' },
          { name: 'GJILAN', name2: 'Përball FSK-së', phone: '+383 44 991 994' },
          { name: 'PRIZREN', name2: 'Lubizhdë - Km. 1', phone: '+383 43 778 778' },
          { name: 'FERIZAJ - Magj.', name2: 'Ferizaj-Prishtinë - Km. 1', phone: '+383 49 640 940' },
          { name: 'PRISHTINË 2', name2: 'Rrethi Marigona Residence', phone: '+383 44 503 399' },
        ];

        const locationsY = pdf.internal.pageSize.getHeight() - 90;
        const locationSpacing = 132;
        const startXPosition = 40;
        const endXPosition = startXPosition + (locations.length - 1) * locationSpacing + 132;

        locations.forEach((location, index) => {
          const xPosition = 40 + index * locationSpacing;
          pdf.setFontSize(8);
          pdf.setTextColor(0, 0, 0);
          const iconXPosition = xPosition - 25;
          const iconYPosition = locationsY - 10;
          pdf.addImage(iconLogo, 'PNG', iconXPosition, iconYPosition, 28, 29);
          pdf.text(location.name, xPosition, locationsY);
          pdf.text(location.name2, xPosition, locationsY + 15);
          pdf.text(location.phone, xPosition, locationsY + 30);
        });

        const lineY = locationsY + 40;
        pdf.setDrawColor(0, 0, 0);
        pdf.line(startXPosition, lineY, endXPosition, lineY);

        const itemsXStart = 40;
        const itemsY = lineY + 3;
        const items = [
          { icon: facebookLogo, text: 'NOTAbrillantOfficial' },
          { icon: instaLogo, text: 'nota.brillant' },
          { icon: mailLogo, text: 'info@notabrillantofficial.com' },
        ];
        const itemSpacing = 150;

        items.forEach((item, index) => {
          const xPosition = itemsXStart + index * itemSpacing;
          pdf.addImage(item.icon, 'PNG', xPosition, itemsY, 20, 20);
          pdf.setFontSize(12);
          pdf.text(item.text, xPosition + 25, itemsY + 15);
        });

        const qrCodeText = 'Blej online';
        const qrCodeTextWidth = pdf.getTextWidth(qrCodeText);
        const qrCodeTextX = 680 + (45 - qrCodeTextWidth) / 2;
        const qrCodeTextY = pdf.internal.pageSize.getHeight() - 60;
        pdf.setFontSize(10);
        pdf.setTextColor(0, 0, 0);
        pdf.text(qrCodeText, qrCodeTextX, qrCodeTextY);
        pdf.addImage(qrCodeLogo, 'PNG', 680, pdf.internal.pageSize.getHeight() - 50, 45, 45);

        const footerText = 'Powered by DigIT';
        const footerTextWidth = pdf.getTextWidth(footerText);
        const centerX = (pdf.internal.pageSize.getWidth() - footerTextWidth) / 2;
        const footerY = pdf.internal.pageSize.getHeight() - 10;
        pdf.setFontSize(10);
        pdf.setTextColor(160, 160, 160);
        pdf.text(footerText, centerX, footerY);
      };

      staticContent();

      // Save PDF
      pdf.save(`${supplierName} - ${moment().format('DD/MM/YYYY - hh:mm:s')}.pdf`);
    },
    togglePopup(rowId) {
      Object.keys(this.showPopup).forEach((id) => {
        if (id !== rowId) {
          this.$set(this.showPopup, id, false);
        }
      });
      this.$set(this.showPopup, rowId, !this.showPopup[rowId]);
    },
  },
};
</script>

<style scoped lang="scss">

.popup {
  width: 155px;
  height: 100px;
  border-radius: 8px 0px 8px 8px;
  position: absolute;
  border: 1px solid #D0D5DD;
  background: white;
  right: 92px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 3%;
}

.actionDelete,
.actionEdit {
  width: 100px;
  height: 40px;
  border-radius: 8px;
  padding: 10px;
  font-size: 16px;
  font-weight: 500;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.actionDelete {
  color: #FF274F;
  border: 1px solid #FF274F;
}

.actionEdit {
  color: #475467;
  border: 1px solid #475467;
}

.pdf-button {
  margin-bottom: 10px;
  border:transparent
}
.pdf-button:hover {
  margin-bottom: 10px;
  background: #FF274F;
  border:transparent
}
.pdf-button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}
.headline{
  display: flex;
  justify-content: space-between;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  border-radius: 8px;
}

.custom-table td {
  padding: 16px 9px;
  border-bottom: 1px solid #ddd;
  text-align: left;
}

.custom-table th {
  padding: 10px;
  border-bottom: 1px solid #ddd;
  text-align: left;
}

.custom-table th:first-child {
  border-radius: 0px 0px 0px 0px;
}

.custom-table th:last-child {
  border-radius: 0px 0px 0px 0px;
}
.custom-table th {
  background-color: #f2f2f2;
}
</style>
